import './Header.css';
import logo from '../imgs/logo_cedoc.png';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Home, Briefcase, Users, Info, Image,
  Headphones, Sparkles, User, Menu, X
} from 'lucide-react';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // aplica/remover classe no <body> para o efeito de blur+lock do fundo
  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  const toggleMenu = () => setMenuOpen(v => !v);
  const closeMenu  = () => setMenuOpen(false);

  return (
    <div className="Header">
      <header className={scrolled ? 'show' : ''}>
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="CEDOC" />
        </Link>

        <div className="menu-toggle" onClick={toggleMenu} aria-label="Abrir menu">
          {menuOpen ? <X size={32} /> : <Menu size={32} />}
        </div>

        <nav aria-label="Menu principal">
          <ul className={`menu ${menuOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={closeMenu}><Home className="nav-icon" />Home</Link></li>
            <li><Link to="/services" onClick={closeMenu}><Briefcase className="nav-icon" />Serviços e Soluções</Link></li>
            <li><Link to="/clients" onClick={closeMenu}><Users className="nav-icon" />Clientes</Link></li>
            <li><Link to="/about" onClick={closeMenu}><Info className="nav-icon" />Sobre nós</Link></li>
            <li><Link to="/galeria" onClick={closeMenu}><Image className="nav-icon" />Galeria</Link></li>
            <li><Link to="/contact" onClick={closeMenu}><Headphones className="nav-icon" />Suporte e Contato</Link></li>
            <li><Link id="demo" to="/formdemo" onClick={closeMenu}><Sparkles />Solicite uma demonstração</Link></li>
            <li><Link id="client" to="/portais" onClick={closeMenu}><User />Área do cliente</Link></li>
          </ul>
        </nav>
      </header>

      {menuOpen && (
        <div className="menu-overlay active" onClick={closeMenu} aria-hidden />
      )}
    </div>
  );
}

export default Header;
